import React from 'react';
import FormInputSearch from './FormInputSearchItem';
import VehicleSearch from '../../search/VehicleSearch';

export default function FormInputVehicleSearch(props) {
  return <FormInputSearch {...props} searchComponent={VehicleSearch} />;
}
